import { defaultPromptMeta } from "../../resources/forms/NewPromptForm/NewPromptFormSchema";
import type { PromptMeta } from "../../../types/Resource";

/**
 * Default working meta seeded into a new draft prompt column. Reuses the same
 * defaults as creating a brand-new prompt in the tree.
 */
const defaultColumnMeta = defaultPromptMeta as PromptMeta;

export { defaultColumnMeta };
